import * as React from 'react';

import styles from './CatalogUsageNotes.scss';

type UsageNote = {
  title: string;
  paragraphs: string[];
};

const usageNotes: UsageNote[] = [
  {
    title: 'ご利用方法',
    paragraphs: ['本ページから、お好きなギフトを選び、商品ページ上の「申し込む」ボタンよりご注文ください。'],
  },
  {
    title: '商品の発送について',
    paragraphs: [
      'お申し込みいただいた商品は、通常、約10日前後でお客様のお手元にお届けいたします。',
      '（商品の準備にお時間をいただく場合、上記の日数よりもお届けに時間を要する場合がございます。あらかじめご了承ください。）',
      '【繁忙期におけるお届けに関する重要なお知らせ】',
      '誠に恐れ入りますが、以下の期間におきましてはご注文が集中し、商品の準備および発送に通常よりお時間を要する場合がございます。',
      '■特にお届けに時間を要する時期',
      '・5月（母の日前後）',
      '・12月（クリスマス・年末年始）',
      '上記期間以外でも、状況によりお届けまでにお時間を頂戴する場合がございます。何卒ご理解とご協力のほどお願い申し上げます。',
    ],
  },
  {
    title: '注意事項1',
    paragraphs: [
      'カタログチケットに記載されている発行日から6ヶ月以内にご注文ください。',
      'いかなる場合でも換金や返品、再発行、期間の延長はお受けできません。',
    ],
  },
  {
    title: '注意事項2',
    paragraphs: ['専用サイトに掲載されている商品情報は在庫状況などにより変更になる可能性があります。'],
  },
  {
    title: '注意事項3',
    paragraphs: [
      'やむを得ない事情により、ご注文の商品をご用意できないことが判明した場合、誠に恐れ入りますが、商品の変更・再申し込みをお願いする場合がございます。',
      'この場合、弊社よりお客様のメールアドレス宛に改めてご連絡させていただきます。',
    ],
  },
];

export const CatalogUsageNotes = (): JSX.Element => (
  <section
    className={styles.section}
    aria-labelledby="catalog-usage-notes-title"
  >
    <div className={styles.box}>
      <h2
        className={styles.title}
        id="catalog-usage-notes-title"
      >
        ご利用の流れ・注意事項
      </h2>

      {usageNotes.map((note) => (
        <div
          key={note.title}
          className={styles.block}
        >
          <h3 className={styles.blockTitle}>{note.title}</h3>
          {note.paragraphs.map((paragraph, paragraphIndex) => (
            <p
              key={`${note.title}-${paragraphIndex}`}
              className={styles.text}
            >
              {paragraph}
            </p>
          ))}
        </div>
      ))}
    </div>
  </section>
);
